import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: 'Serve para qualquer tema de casamento?',
  answer: 'Sim! O guia tem ideias para 6 estilos diferentes: rústico, romântico, minimalista, moderno, clássico e boho. Além disso, cada ideia vem com sugestões de adaptação para o seu tema específico. Você encontra opções que combinam perfeitamente com o seu casamento.'
}, {
  question: 'Preciso saber fazer artesanato?',
  answer: 'Não! As ideias foram pensadas especificamente para quem NÃO tem habilidade manual. Se você consegue colar, amarrar e organizar, você consegue fazer. Não tem nada de complicado, nada de técnicas difíceis. É tudo simples, rápido e direto ao ponto.'
}, {
  question: 'E se eu não tiver tempo?',
  answer: 'A maioria das ideias leva menos de 5 minutos por unidade. Você pode fazer aos poucos, no seu ritmo, enquanto assiste TV ou ouve música. Muitas noivas fazem tudo em um único fim de semana. E se você tiver ainda menos tempo, o guia também mostra as ideias mais rápidas de todas.'
}, {
  question: 'Tem ideias realmente baratas?',
  answer: 'Sim! Tem ideias que custam menos de R$0,50 por unidade. A maioria fica entre R$0,80 e R$2,00. E todas elas parecem muito mais caras do que realmente são. O guia mostra exatamente quanto cada ideia custa, para você escolher dentro do seu orçamento.'
}, {
  question: 'Tem ideias diferentes do Pinterest?',
  answer: 'Sim! O diferencial não está apenas nas ideias (que são lindas e testadas), mas no COMO fazer parecer caro. O Pinterest te mostra fotos. O guia te ensina o Efeito Boutique™: proporção, composição e microdetalhes que transformam algo simples em algo elegante.'
}, {
  question: 'Como recebo o guia?',
  answer: 'Imediatamente após a confirmação do pagamento, você recebe um email com o link de acesso. É tudo digital, disponível 24/7, para você acessar quando e onde quiser.'
}, {
  question: 'E se eu não gostar?',
  answer: 'Você tem garantia total. Se não achar pelo menos 5 ideias lindas e possíveis de fazer, devolvo 100% do valor. Sem perguntas, sem complicação. Você não tem nada a perder.'
}];
function FAQItem({
  question,
  answer,
  index
}: {
  question: string;
  answer: string;
  index: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay: index * 0.05,
    duration: 0.5
  }} className="bg-white rounded-xl md:rounded-2xl shadow-lg overflow-hidden" data-id="element-38">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-5 py-4 md:px-7 md:py-5 flex items-center justify-between text-left hover:bg-amber-50 transition-colors duration-200" data-id="element-39">
        <span className="text-base md:text-lg font-semibold text-stone-900 pr-3 md:pr-4" data-id="element-40">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} data-id="element-41">
          <ChevronDown className="w-5 h-5 md:w-6 md:h-6 text-amber-600 flex-shrink-0" data-id="element-42" />
        </motion.div>
      </button>

      <AnimatePresence data-id="element-43">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-44">
            <div className="px-5 pb-4 md:px-7 md:pb-5" data-id="element-45">
              <p className="text-sm md:text-base text-stone-700 leading-relaxed" data-id="element-46">
                {answer}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}
export function FAQSection() {
  return <section className="py-12 md:py-20 bg-gradient-to-br from-amber-50 via-yellow-50 to-stone-50" data-id="element-47">
      <div className="max-w-3xl mx-auto px-4 md:px-6" data-id="element-48">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 md:mb-14" data-id="element-49">
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-stone-900 mb-3 md:mb-5" data-id="element-50">
            Perguntas Frequentes
          </h2>
          <p className="text-base md:text-lg text-stone-600" data-id="element-51">
            Tudo o que você precisa saber antes de decidir
          </p>
        </motion.div>

        <div className="space-y-3 md:space-y-4" data-id="element-52">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} index={index} data-id="element-53" />)}
        </div>
      </div>
    </section>;
}